const addonBlocks = {
    
}

const getAddonBlocks = (config) => {
    return addonBlocks;
};
export default getAddonBlocks;